// Normalized, defensive feature-flag handling used across the app.

export const DEFAULT_FLAGS = ["reservations", "month", "settings", "overview"];

/** Return a Set of normalized flags */
export function parseFeatureFlags(s = "") {
  return new Set(
    String(s || "")
      .split(/[,\s]+/)
      .map(v => v.trim())
      .filter(Boolean)
  );
}

/** True if flag is present in the set */
export function hasFlag(flagsSet, key) {
  if (!flagsSet) return false;
  return flagsSet.has(String(key).toLowerCase());
}

/** Return a canonical, comma-separated string (for storage) */
export function ensureFlagsString(input) {
  return [...parseFeatureFlags(input)].join(",");
}

/** Merge default flags with a new list (deduped) */
export function mergeFlags(existing, extra) {
  const set = parseFeatureFlags(existing);
  for (const f of parseFeatureFlags(extra)) set.add(f);
  return [...set].join(",");
}


export function flagsToString(flags) {
  const arr = Array.from(flags instanceof Set ? flags : new Set(flags));
  return arr.sort().join(",");
}
